export const directoryStrings = {
  UNSUPPORTED_LANG_ALERT_COPY_TEXT: 'DIRECTORY:ALERT_BANNER:UNSUPPORTED_LANGUAGE:COPY_TEXT',
  SEARCH_INPUT_PLACEHOLDER: 'DIRECTORY:SEARCH:INPUT:PLACEHOLDER',
  SEARCH_INPUT_CLEAR_SEARCH_LABEL: 'DIRECTORY:SEARCH:INPUT:CLEAR_SEARCH_LABEL',
  ADD_TO_COMPARE_TEXT: 'DIRECTORY:PARTNER_CARD:ADD_TO_COMPARE',
  CONTACT_PARTNER: 'DIRECTORY:PARTNER_CARD:CONTACT_PARTNER',
  VIEW_PARTNER_PROFILE: 'DIRECTORY:PARTNER_CARD:VIEW_PROFILE',
  SELECT_ANOTHER_PARTNER: 'DIRECTORY:PARTNER_COMPARISON_CART:SELECT_ANOTHER_PARTNER',
  SELECT_ANOTHER_PARTNER_TO_COMPARE: 'COMPARISON_DETAILS:SELECT_ANOTHER_PARTNER_TO_COMPARE',
  CONTACT_PARTNER_CONCISE: 'COMPARISON_DETAILS:PARTNER_CARD:CONTACT_PARTNER',
  REMOVE_PARTNER_LABEL: 'DIRECTORY:PARTNER_COMPARISON_CART:REMOVE_PARTNER_LABEL',
  ADVANCED_TEXT: 'DIRECTORY:PARTNER_CARD:ADVANCED_PARTNER:STATUS',
  VERIFIED_TEXT: 'DIRECTORY:PARTNER_CARD:VERIFIED_PARTNER:STATUS',
  CLEAR_ALL: 'DIRECTORY:PARTNER_COMPARISON_CART:CLEAR_ALL',
  COMPARE_PARTNERS: 'DIRECTORY:PARTNER_COMPARISON_CART:COMPARE_PARTNERS',
  PARTNER_COMPARISON_ERROR: 'DIRECTORY:PARTNER_COMPARISON:ERROR',
  ERROR_DISMISS: 'SHARED:ERROR_DISMISS',
  COMPARE_PARTNERS_TEXT: 'COMPARISON_DETAILS:COMPARE_PARTNERS',
  KEY: 'COMPARISON_DETAILS:LEGEND:KEY_TEXT',
  VERIFIED_BY_AMAZON: 'COMPARISON_DETAILS:LEGEND:VERIFIED_BY_AMAZON',
  SUPPORTED_BY_PARTNER: 'COMPARISON_DETAILS:LEGEND:SUPPORTED_BY_PARTNER',
  REMOVE: 'COMPARISON_DETAILS:REMOVE',
  SELECTED_WITH_COUNT: 'DIRECTORY:PARTNER_COMPARISON_CART:SELECTED_WITH_COUNT',
  CLEAR_SELECTION: 'DIRECTORY:PARTNER_COMPARISON_CART:CLEAR_SELECTION',
  RECOGNITIONS: 'COMPARISON_DETAILS:RECOGNITIONS',
  BACK_TO_DIRECTORY: 'COMPARISON_DETAILS:LINK:BACK_TO_DIRECTORY',
  BACK_TO_TOP: 'COMPARISON_DETAILS:LINK:BACK_TO_TOP',
  ICON_SELECT_ANOTHER_PARTNER: 'COMPARISON_DETAILS:SELECT_ANOTHER_PARTNER_ICON',
  NAVIGATE_NEXT_ICON: 'COMPARISON_DETAILS:NAVIGATE_NEXT_ICON',
  NAVIGATE_PREVIOUS_ICON: 'COMPARISON_DETAILS:NAVIGATE_PREVIOUS_ICON',
  COMPANY_LOGO_LABEL: 'DIRECTORY:PARTNER_CARD:COMPANY_LOGO_TEXT',
  TABLE_SERVICES: 'COMPARISON_DETAILS:TABLE:SERVICES',
  TABLE_SERVICES_WITH_COUNT: 'COMPARISON_DETAILS:TABLE:SERVICES_WITH_COUNT',
  TABLE_PRODUCTS: 'COMPARISON_DETAILS:TABLE:PRODUCTS',
  TABLE_PRODUCTS_WITH_COUNT: 'COMPARISON_DETAILS:TABLE:PRODUCTS_WITH_COUNT',
  TABLE_COUNTRIES: 'COMPARISON_DETAILS:TABLE:COUNTRIES',
  TABLE_COUNTRIES_WITH_COUNT: 'COMPARISON_DETAILS:TABLE:COUNTRIES_WITH_COUNT',
  TABLE_CERTIFICATIONS: 'COMPARISON_DETAILS:TABLE:CERTIFICATIONS',
  TABLE_CERTIFICATIONS_WITH_COUNT: 'COMPARISON_DETAILS:TABLE:CERTIFICATIONS_WITH_COUNT',
  TABLE_MORE_DETAILS: 'COMPARISON_DETAILS:TABLE:MORE_DETAILS',
  TABLE_RECOGNITIONS: 'COMPARISON_DETAILS:TABLE:RECOGNITIONS',
  TABLE_AWARDS_AND_SPECS: 'COMPARISON_DETAILS:TABLE:AWARDS_AND_SPECS',
  VERIFIED_BY_AMAZON_ICON: 'COMPARISON_DETAILS:LABEL_ICON_VERIFIED_BY_AMAZON',
  CLAIMED_BY_PARTNER_ICON: 'COMPARISON_DETAILS:LABEL_ICON_CLAIMED_BY_PARTNER',
  BANNER_LANGUAGE_NOT_SUPPORTED: 'COMPARISON_DETAILS:BANNER:PARTNERS_NOT_SUPPORTED',
  BANNER_SELECT_ANOTHER_PARTNER: 'COMPARISON_DETAILS:BANNER:SELECT_ANOTHER_PARTNER',
  TOOL_PROVIDER_WEBSITE: 'DETAILS_PAGE:CONTACT:PARTNER_CARD:BUTTON_TOOL_PROVIDER_WEBSITE',
  NOT_ACCEPTING_NEW_BUSINESS: 'DETAILS_PAGE:CONTACT:PARTNER_CARD:BUTTON_NOT_ACCEPTING_BUSINESS',
  ACCEPTING_NEW_BUSINESS: 'DIRECTORY:ACCEPTING_NEW_BUSINESS',
}
